import { store } from './store';
import { firebase } from '../../utilities';
import DB from '../../DAL/DB';
import { auth } from '../../Auth';
import { Timestamp, deleteField } from 'firebase/firestore'


const projects = new DB.Projects();

/**
 * Silent save function that only updates the project data to Firestore.
 * This function is intended to run in the background without impacting UI or triggering re-renders.
 */
export async function silentSaveIntake() {
  return;
  /* 
  

  const state = store.getState();
  const { project, sections, fields } = state;

  // Skip if a save/finalization is already in progress — avoids overwriting a concurrent saveIntake call.
  if (state.status?.loading) {
    console.info('Skipping silent save: a save operation is already in progress.');
    return;
  }

  // No point auto-saving a completed project; doing so risks overwriting finalized data.
  if (project?.status === 'Completed') {
    console.info('Skipping silent save: project is already Completed.');
    return;
  }

  // Validate required state properties
  if (!project?.id || !project.intake?.sections || !sections || !fields) {
    console.error('Invalid state: Missing project, sections, or fields');
    return;
  }

  // Build intake sections immutably
  const intakeSections = Object.keys(sections).reduce((acc, sectionId) => ({
    ...acc,
    [sectionId]: {
      ...sections[sectionId],
      fields: (sections[sectionId].order || []).map((fId) => fields[fId]).filter(Boolean),
    },
  }), {});

  // Prepare project data for Firestore immutably
  let projectData = {
    ...project,
    intake: {
      ...project.intake,
      sections: intakeSections,
    },
    photos: fields[project.id]?.images || {},
    updated: Timestamp.now(),
    updatedBy: auth?.sunkaizenUser?.id || null,
    updatedByName: auth?.sunkaizenUser?.name || null,
  };

  // Remove completed fields if status is not 'Completed'
  if (projectData.status !== 'Completed') {
    projectData = {
      ...projectData,
      completed_on: deleteField(),
      completed_by: deleteField(),
    };
  }

  try {
    await projects.updatebatch(project.id, null, projectData);
    console.info('Silent save completed successfully.');
  } catch (e) {
    console.error('Error during silent save to Firestore:', e);
  }
  */
}